export default __webpack_public_path__ + "static/media/Saw.1f83fa51.mp3";